import { __assign } from "tslib";
import { memoizeFunction } from '@fluentui/react/lib/Utilities';
import { DefaultFontStyles, HighContrastSelector, FontSizes, FontWeights, mergeStyleSets, } from '@fluentui/react/lib/Styling';
import { baseFabricFocusSelector } from '@ms/app-commanding-ui';
export var controlDimensions = {
    versionHistoryHeight: 20,
};
var getLinkStyle = function (colors) { return ({
    color: colors.primary,
    background: 'transparent',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    fontWeight: 'normal',
    fontSize: FontSizes.medium,
    textDecoration: 'none',
    cursor: 'pointer',
}); };
var getLinkSelectorStyle = function (colors) {
    var _a, _b, _c;
    return ({
        selectors: (_a = {
                ':hover, :active': {
                    color: colors.hoverBackground,
                    background: 'transparent',
                    selectors: (_b = {},
                        _b[HighContrastSelector] = {
                            color: 'highlight',
                        },
                        _b),
                }
            },
            _a[":focus, " + baseFabricFocusSelector] = {
                color: colors.hoverBackground,
                background: 'transparent',
                outline: colors.hoverBackground + " dashed 1px",
                selectors: (_c = {},
                    _c[HighContrastSelector] = {
                        color: 'highlight',
                    },
                    _c),
            },
            _a),
    });
};
var getAppButtonLinkSelectorStyle = function (colors) {
    var _a;
    return ({
        selectors: (_a = {
                ':hover, :active': {
                    color: colors.hoverBackground,
                    background: 'transparent',
                }
            },
            _a[":focus, " + baseFabricFocusSelector] = {
                color: colors.hoverBackground,
                background: 'transparent',
                outline: colors.hoverBackground + " dashed 1px",
            },
            _a),
    });
};
var getDocumentTitleCalloutContentStyles = memoizeFunction(function () {
    return {
        root: [
            DefaultFontStyles.medium,
            {
                width: '100%',
                padding: 16,
                boxSizing: 'border-box',
                boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.1)',
                borderRadius: 2,
            },
        ],
    };
});
var getLabelStyles = memoizeFunction(function () {
    return {
        root: {
            padding: '0px',
        },
        label: {
            padding: '0px',
        },
    };
});
var getClassNames = function (colors) {
    var linkStyles = getLinkStyle(colors);
    var linkSelectorStyles = getLinkSelectorStyle(colors);
    var appButtonLinkSelectorStyles = getAppButtonLinkSelectorStyle(colors);
    return mergeStyleSets({
        documentExtension: {
            fontWeight: FontWeights.regular,
            fontSize: FontSizes.small,
        },
        flexContainer: {
            display: 'flex',
        },
        documentTitleSection: {
            display: 'flex',
            flexDirection: 'column',
        },
        saveStatusSection: {},
        saveStatusValue: {
            paddingTop: '8px',
        },
        sectionDivider: {
            height: '24px',
        },
        versionHistorySection: {
            display: 'flex',
            flexDirection: 'column',
        },
        sectionName: {
            display: 'block',
            paddingBottom: 10,
        },
        versionHistory: {
            display: 'flex',
            padding: '2px',
        },
        versionHistoryIcon: {
            marginInlineEnd: 8,
            maxHeight: controlDimensions.versionHistoryHeight,
            maxWidth: controlDimensions.versionHistoryHeight,
            fill: colors.primary,
        },
        versionHistoryTitle: __assign(__assign(__assign({}, linkStyles), linkSelectorStyles), { display: 'inline-flex', alignItems: 'center', fontSize: FontSizes.small, height: controlDimensions.versionHistoryHeight, border: 'none', padding: 0 }),
        versionHistoryTitleAppButton: __assign(__assign(__assign({}, linkStyles), appButtonLinkSelectorStyles), { display: 'inline-flex', alignItems: 'center', fontSize: FontSizes.small, height: controlDimensions.versionHistoryHeight, border: 'none', padding: 0 }),
        messageSection: {
            marginBottom: 12,
        },
    });
};
export var getDocumentTitleCalloutStyles = memoizeFunction(function (colors) { return ({
    calloutContent: getDocumentTitleCalloutContentStyles(),
    classNames: getClassNames(colors),
    labelStyles: getLabelStyles(),
}); });
//# sourceMappingURL=DocumentTitleCallout.styles.js.map